module.exports = "/_next/static/images/UnifyCustomerProfile@2x-f3d21002bb88565e7bcaa2e91a31adba.webp";